module.exports = __webpack_public_path__ + "img/service-bg1.461b1b34.png";